import React, {useState} from 'react';
import {createUseStyles, useTheme} from 'react-jss';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import * as R from 'ramda';

import Container from '@components/Container';

import CertificateModal from '@modules/Modal/CertificateModal';

import {lockScroll} from '@utils/ui';

const useStyles = createUseStyles(({
  rem,
}) => ({
  root: {
    width: '100%',
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    padding: [rem(10), rem(20)],
    color: 'rgba(0, 0, 0, 1)',
    backgroundColor: 'rgba(255, 255, 255, 1)',
  },
  title: {
    fontSize: rem(16),
    '& > span': {
      marginLeft: rem(20),
    }
  },
  slider: {
    display: 'flex',
    maxWidth: '100%',
    overflowX: 'auto',
    marginTop: 30,
    padding: 0,
    listStyleType: 'none',
    whiteSpace: 'nowrap',
    fontSize: 0,
    '-webkit-overflow-scrolling': 'touch',
  },
  hideBar: {
    '&::-webkit-scrollbar': {
      display: 'none',
    }
  },
  sliderItem: {
    display: 'flex',
    flexDirection: 'column',
    height: 'auto',
    lineHeight: 1.2,
    textAlign: 'center',
    whiteSpace: 'pre-line',
    boxSizing: 'border-box',
    cursor: 'pointer',
    '& + &': {
      marginLeft: rem(10),
    },
  },
  sliderImage: {
    width: rem(148),
    height: rem(200),
    verticalAlign: 'middle',
    borderRadius: rem(5),
    border: '1px solid #ccc',
    boxShadow: '0px 1px 1px -1px rgba(13, 38, 91, 0.08), 0px 3px 3px 0px rgba(13, 38, 91, 0.06), 0px 5px 6px 2px rgba(13, 38, 91, 0.04)',
  },
  sliderTitle: {
    fontSize: 12,
    color: '#262626',
    padding: [0, rem(10)],
    minHeight: 24,
    margin: [10, 0],
  },
  center: {
    display: 'flex',
    justifyContent: 'center',
    '& > li': {
      display: 'block',
    }
  },
  details: {
    '& > img': {
      width: '100%',
    }
  },
}), {
  name: 'Certificate'
});

// 检测证书
const Certificate = (props) => {
  const theme = useTheme();
  const classes = useStyles(theme);

  const { t, data, language } = props;

  const [currIdx, setCurrIdx] = useState(null);
  const [certificateOpen, setCertificateOpen] = useState(false);
  // 证书下面商品详情图片数据
  const skuData = R.pathOr({}, ['jsonData', 'sku'])(data);
  const detailsData = R.pathOr([], ['custom', 'otherimagelist'])(skuData);

  const dcp1Data = R.pathOr([], ['jsonData', 'dcp1'])(data);
  const dcp2Data = R.pathOr([], ['jsonData', 'dcp2'])(data);
  const dcp3Data = R.pathOr([], ['jsonData', 'dcp3'])(data);
  const dcp4Data = R.pathOr([], ['jsonData', 'dcp4'])(data);

  // 组合证书图片数据
  const combineData = () => {
    const certList = [];
    const arr = [...dcp1Data, ...dcp2Data, ...dcp3Data, ...dcp4Data];
    arr.forEach(item => {
      const certlist = R.pathOr([], ['custom', 'certlist'])(item);
      certList.push(...certlist);
    });
    return certList;
  }

  const certList = combineData();

  const handleOpenModal = (idx) => {
    lockScroll();
    setCurrIdx(idx);
    setCertificateOpen(true);
  }

  const hasCertList = (certList && certList.length > 0);

  return (
    <Container className={classNames(classes.root)}>
      {
        hasCertList ? (<Container flex alignItems="center" className={classes.title}>
        <img
          src="./static/images/products/icon_cert.png"
          alt={t('certificate')}
          height={42}
          width={40}
        />
        <span>{t('certificate')}</span>
      </Container>) : null
      }
      {
        hasCertList ? (
          <ul className={classNames(classes.slider, (certList.length <= 2) && classes.center)}>
            {
              certList.map((item, index) => (
                <li
                  key={String(index)}
                  onClick={() => handleOpenModal(index)}
                  className={classNames(classes.sliderItem)}
                >
                  <img
                    alt='cert'
                    src={R.pathOr('', ['filelocation'])(item)}
                    className={classes.sliderImage}
                  />
                  <h3 className={classes.sliderTitle}>
                    {t('certificate')} {index + 1}
                  </h3>
                </li>
              ))
            }
          </ul>
        ) : null
      }
      <div className={classes.details}>
        {
          detailsData && detailsData.length > 0 ? (
            detailsData.map((item, index) => (
              <img
                key={String(index)}
                alt='details'
                src={R.pathOr('', ['filelocation'])(item)}
                width={320}
              />
            ))
          ) : null
        }
      </div>

      {
        certificateOpen && (
          <CertificateModal
            t={t}
            currIdx={currIdx}
            language={language}
            setCertificateOpen={setCertificateOpen}
          />
        )
      }
    </Container>
  )
};

Certificate.propTypes = {
  t: PropTypes.func.isRequired,
  data: PropTypes.object.isRequired,
  language: PropTypes.string.isRequired,
}

export default Certificate;
